import {Component, OnInit} from '@angular/core';
import {Router, RouterOutlet} from '@angular/router';
import {
	NgbAlertModule,
	NgbDropdownModule,
	NgbModal,
	NgbModalRef,
	NgbModule,
	NgbNavModule
} from "@ng-bootstrap/ng-bootstrap";
import {NavComponent} from "./nav/nav.component";
import {TermsAgreement} from "./terms/terms.agreement";
import {NgIf} from "@angular/common";
import {TemplateService} from "./template.service";
import {ProfileManufacturerAgreementDto, RequestResponse} from "../shipper";
import {KeycloakEvent, KeycloakEventType, KeycloakService} from "keycloak-angular";
import {DEFAULT_INTERRUPTSOURCES, Idle} from "@ng-idle/core";
import {Keepalive} from '@ng-idle/keepalive';
import {AppSessionModal} from "./app.session.modal";

@Component({
	selector: 'app-root',
	standalone: true,
	imports: [RouterOutlet, NgbModule, NgbAlertModule, NgbNavModule, NgbDropdownModule, NavComponent, NgIf],
	providers:[Idle],
	templateUrl: './app.component.html',
	styleUrl: './app.component.css'
})
export class AppComponent implements OnInit {
	
	sessionModal!:NgbModalRef;
	
	countdown:number = 0;
	
	constructor(
		private keycloak: KeycloakService,
		private modal:NgbModal,
		private router:Router,
		private service:TemplateService,
		private idle: Idle,
		private keepalive: Keepalive
	){
		
		this.initIdleEvents();
	}
	
	
	ngOnInit(): void {
		
		this.service.getTerms().subscribe((agreements) => {
			
			if(agreements.length > 0){
				this.showTerms(agreements);
			}
		});
		
	}
	
	
	
	initIdleEvents(){
		
		this.idle.setIdle(60*15);
		this.idle.setTimeout(20);
		
		this.idle.onIdleStart.subscribe(() => this.show());
		//this.idle.onIdleEnd.subscribe(() => this.reset());
		
		this.idle.onTimeout.subscribe(() => {
			this.keycloak.logout().then(() => {
				console.log("timeout!");
			});
		});
		
		
		this.idle.onTimeoutWarning.subscribe((countdown) => {
			if(this.sessionModal !== undefined && this.sessionModal !== null){
				this.sessionModal.componentInstance.countdown = countdown;
			}
		});
		
		
		//this.keepalive.interval(15);
		this.idle.watch();
		this.idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);
		//this.reset();
	}
	
	
	show(){
		
		if(this.sessionModal === undefined || this.sessionModal == null){
			
			this.idle.clearInterrupts();
			
			this.sessionModal = this.modal.open(AppSessionModal,{backdrop:"static"});
			//this.sessionModal.componentInstance.countdown = this.countdown;
			this.sessionModal.componentInstance.onUserHere.subscribe(() => {
				this.reset();
				
				//this.close();
				window.location.reload();
				//this.keycloak.updateToken(5).then(() => console.log("Token update"))
				
			});
		}
		
		
	}
	
	
	close(){
		if(this.sessionModal){
			this.sessionModal.close();
		}
	}
	
	
	reset() {
		this.idle.watch();
		this.idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);
	}
	
	
	
	
	
	
	
	
	initKcEvents(){
		
		this.keycloak.keycloakEvents$.subscribe({
			
			next: (e:KeycloakEvent) => {
				
				if(e.type == KeycloakEventType.OnAuthSuccess){
					//console.log("OnAuthSuccess");
				}
				
				if(e.type == KeycloakEventType.OnTokenExpired){
					//console.log("OnTokenExpired");
				}
				
				if(e.type == KeycloakEventType.OnAuthRefreshError){
					//console.log("OnAuthRefreshError");
				}
			}
		});
	}
	
	
	
	isErrorPage(){
		return this.router.url == "/deny";
	}
	
	
	/**
	 *
	 * @param agreements
	 */
	showTerms(agreements:Array<ProfileManufacturerAgreementDto>){
		
		let modal = this.modal.open(TermsAgreement,{fullscreen:true, scrollable:true});
		
		modal.componentInstance.agreements = agreements;
		
		modal.componentInstance.onYes.subscribe((a:Array<ProfileManufacturerAgreementDto>) => {
			
			this.service.setTerms(a).subscribe((re:RequestResponse) => {
				
				if(re.status == "ACCEPTED"){
					modal.close();
					this.router.navigate(["/isf"]).then(() => console.log(this.router.url));
				}
			});
		});
		
		modal.componentInstance.onNo.subscribe(() => {
			modal.close();
			this.router.navigate(["/deny"]).then(() => console.log(this.router.url));
		});
	}
	
}
